<template>
	<!-- <div class="unlock-order-aside"> -->
	<o-page :title="setup.route.name === 'OrderDashboardAgencyParams' ? 'Paramètre agences' : undefined">
		<o-section
			v-if="!setup.selectAllAgencies"
			class="unlock-order-aside__section"
			:title="`Agence`.pluralize(setup.listProps.total, true)">
			<template #actions>
				<o-toggle
					v-model="setup.filter.showIsActivated"
					reverse
					label="Afficher seulement les agences ayant débloqué le module"/>
				<o-icon
					v-if="setup.canSelectAll"
					font-icon="icon-interface-validation-check"
					@click="setup.selectAllListItems()"/>
			</template>
			<div class="unlock-order-aside__filter">
				<o-input
					v-model="setup.filter.research"
					suffix-font-icon="icon-interface-search"
					label="Chercher par nom..."
					@change="setup.refreshListAsync()"/>
				<o-select
					v-model="setup.filter.order.property"
					label="Trier par"
					display-key="label"
					track-key="value"
					value-key="value"
					clearable
					:options="setup.sortByOptions"
					@input="setup.refreshListAsync()"/>
			</div>
			<o-list
				ref="agenciesList"
				v-model:page="setup.listPage"
				class="unlock-order-aside__list"
				v-bind="setup.listProps">
				<template #default="{ item }">
					<unlock-module-order-agency-card
						:agency="item"
						:selected="setup.listItemIsSelected(item)"
						@select="setup.selectListItem(item)"
						@unlock="setup.unlockAsync($event, true)"/>
				</template>

				<template #footer-selected-actions>
					<o-button
						color="info"
						outline
						@click="setup.unlockAsync()">
						Demander le déblocage
					</o-button>
				</template>
			</o-list>

			<div
				v-if="setup.listProps.total === 0"
				class="unlock-order-aside__empty">
				<o-icon font-icon="icon-interface-home-2"/>
				<span>Aucune agence n'a été trouvée</span>
			</div>
		</o-section>
	</o-page>
	<!-- </div> -->
</template>

<script setup lang="ts">
import UnlockModuleOrderListSetupService from '@/setup/unlock-module/order/UnlockModuleOrderListSetupService';
import UnlockModuleOrderAgencyCard from '@/components/unlock-module/order/UnlockModuleOrderAgencyCard.vue';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
// const props = defineProps(UnlockModuleOrderListSetupService.props);
const setup = new UnlockModuleOrderListSetupService(undefined, _aside);
</script>


<style scoped lang="less">
@import '@/styles/variables';
@import '@/styles/mixins';
	.unlock-order-aside {
		&__section{
			h2 {
				font-size: 1.5rem;
			}
			.orion-section__header{
				align-items: center;
			}
		}

		&__list {
			padding-bottom: 10rem;
		}

		&__filter{
			display: flex;
			gap: 1rem;
			margin-bottom: 1rem;
			align-items: center;

			.orion-input{
				margin: unset;
			}
			& * {
				flex: 1;
			}
		}

		&__empty {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			.orion-icon{
				font-size: 6.25rem;
				color: var(--grey-light);
				margin-bottom: 0.9rem;
			}
			span{
				font-style: italic;
				color: var(--grey);
			}
		}
	}
</style>
